import Input from "../../../../Core/Fields/Floating/Input";
import SelectSearch from "../../../../Core/Fields/Floating/SelectSearch";

const TaxDetails = ({ formData, handleChange, errors }) => {
  const gstCategories = [
  { name: "Registered Regular" },
  { name: "Registered Composition" },
  { name: "Unregistered" },
  { name: "SEZ" },
  { name: "Overseas" },
  { name: "Deemed Export" },
  { name: "UIN Holders" },
  { name: "Tax Deductor" },
  { name: "Tax Collector" },
  { name: "Input Service Distributor" }
];


  return (
    <div className="row mb-3" style={{ border: "1px solid #00000059", borderRadius: "5px" }}>
      <div className="col-12">
        <p className="boxLabel m-0">Tax Details</p>
      </div>

      <div className="col-4">
        <div className="mb-3">
          <Input
            id="gstinUin"
            label="GSTIN/UIN"
            style={{ height: "30px", border: errors.gstinUin ? "1px solid red" : "" }}
            value={formData.gstinUin}
            onChange={(e) => handleChange('gstinUin', e.target.value)}
          />
        </div>
      </div>
      
      <div className="col-4">
        <div className="mb-3">
          <Input
            id="pan"
            label="PAN"
            style={{ height: "30px", border: errors.pan ? "1px solid red" : "" }}
            value={formData.pan}
            onChange={(e) => handleChange('pan', e.target.value)}
          />
        </div>
      </div>
      
      <div className="col-4">
        <div className="mb-3">
          <SelectSearch
            list={gstCategories}
            label="GST Category"
            getOptionLabel={(item) => item.name}
            getOptionValue={(item) => item.name}
            value={formData.gstCategory}
            onChange={(val) => handleChange('gstCategory', val)}
          />
        </div>
      </div>
    </div>
  );
};

export default TaxDetails;